<template>
    <div id="vy_main" style="overflow-x:hidden">
      <main>
        <!--ヘッダー-->
        <HeaderArea />

        <div id="main_area">
          <h2>プライバシーポリシー（ボラ活エール）</h2>
          <div id="Policy_Condition_area">
          <b>１．事業者情報</b><br>
          本システムは、以下の事業者が外部業者に開発、運営を委託するものである。<br><br>
          法人名：さんこう株式会社<br>
          住 所：埼玉県川越市新富町1-9-1<br>
          代表者：木所 裕幸<br><br>

          <b>２．システムの利用者</b><br>
          本システムの利用者は、以下の３者です。<br><br>
          （１）一般利用者<br>
          本システムを通じて種々のサービスの提供を受ける者<br>
          ① 学生<br>
          ② 成人<br>
          ③ その他<br><br>
          （２）サービス提供者<br>
          本システムを通じて種々のサービスを提供する主体<br>
          ① 各市区町村の社会福祉協議会<br>
          ② 一般の福祉団体<br><br>
          （３）提供されるサービスの内容<br>
          ① 体験ボランティアの斡旋と管理<br>
          ② ボランティアの斡旋と管理<br>
          <br>
          <b>３．システム運用における個人情報保護</b><br>
          （１）個人情報の取得<br>
          本システムにおいて個人情報は、サービス利用者本人が本プライバシーポリシーへ同意の上、システムの画面へ入力することにより取得します。<br><br>
          （２）個人情報の利用目的<br>
          本システムが取得管理する個人情報は、すべて上記２．（３）に掲載された提供サービスの運営のために利用し、それ以外の目的では使用しません。<br><br>
          （３）個人情報の安全管理<br>
          本システムでは、個人情報は本人のマイページ以外のサービス利用者のページには表示しません。<br>
          サービス提供者は、本システムを通じて本人の同意の上で取得した個人情報を自己の定める個人情報保護方針に則ってサービス運営のためだけに利用します。<br>
          本システムの運営者は、個人情報ファイルへのアクセス制限の実施、アクセスログの記録及び外部からの不正アクセス防止のためのセキュリティ対策の実施、ウイルス対策ソフトの導入等により、全ての個人情報に対して、不正アクセス、盗難、持ち出し等による紛
          失、破壊、改ざん及び漏えい等が起こらないように適正に管理し、必要な予防・是正措置を講じます。また、取得された個人情報をデータ管理以外に使用することはしません。<br><br>
          （４）個人情報の開示、訂正等<br>
          本システムで取得、保管する個人情報は、本人とサービス提供者の画面にのみ表示されます。また、その訂正等は、本人による訂正かまたはサービス提供者が代行する場合（本人が操作できない場合等）に限ります。<br><br>
          （５）個人情報の第三者への提供<br>
          本システムで取得、保管する個人情報のうち、サービス提供者がボランティアを斡旋する上において必要な情報のみを予め本人の同意を得て斡旋先に提供します。<br><br>

          <b>４．サービス提供者における個人情報保護</b><br>
          サービス提供者は、本システムで取得した個人情報をサービス運営に利用するため、それぞれに個人情報保護方針を定め運用します。その内容は、各々のサービス提供者が本システムを通じて公開しており、個人情報の提供者が参照できます。<br>
          <br>
          
          <b>５．サービス利用者における個人情報保護</b><br>
          本システムを通じたサービスの利用者は、個人情報として入力した情報が一般の人に公開されることはありませんが、それ以外の一般情報欄への入力情報は、公的な露出の可能性があるため、そこへ個人情報を入力しないように気をつける必要があります。<br>
          <br>
          <b>６．法令の遵守</b><br>
          本システムの運営全般において、「個人情報の保護に関する法律」（平成15年法律第57号）及びその他の個人情報保護に関する法令と規範を遵守します。<br>
          <br>
          <b>７．個人情報に関するお問い合わせ先</b><br>
          個人情報に関するお問合せは、一般のお問合せを含めて、利用者画面の「お問合せ」リンクより行うか、または「１．事業者情報」に掲載された事業者宛てにお願いします。<br><br>
          
          <div style="width:100%;text-align:right">以上</div>
          </div>
        </div>
        <!--フッター-->
        <FooterArea />
      </main>
    </div>

    
     <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
     <div class="vy-responsive-menu-container floating_over"  style="
          padding: 10px 0;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">
          <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="return_page()">戻る</button>
          
      </div>
</template>
  
    
<script setup>
  /* eslint-disable */
  import HeaderArea from './HomeHeader.vue'
  import FooterArea from './HomeFooter.vue'

    
  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  import { shallowRef, watch, ref } from 'vue'
  import { useRouter } from 'vue-router'
  const router = useRouter()
  const content = shallowRef('')

  const return_page = () =>{
    if(router.go(-1)){
      alert(router.go(-1))
      router.go(-1)
    }else{
      window.close()

    }
  }

  // 選択中の社協
  let shakyo = ref("kawagoe")

  
  let Taiken = function(){
    let set_path = "/"+shakyo.value+"/Taiken"
    window.open(set_path,"_blank")
  }

  let Volunter = function(){
    alert("準備中です。")
  }

  let ShakyoPolicy = function(){
    let set_path = "/"+shakyo.value+"/Taiken/Policy"
    window.open(set_path,"_blank")
  }
</script>
  
<style scoped>

  #main_area{
    margin-top:30px;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #link_area{
    font-size: 17px;
    display: flex;
    justify-content: space-evenly;
    width: 50%;
    height: 200px;
    align-items: center;
    flex-direction: column;
  }
  #link_area span{
    color:black;
    cursor: pointer;
    text-decoration-line:underline
  }
  /* レスポンシブ対応 */
  @media screen and (max-width: 960px) {
    /*スマホ*/
    .jokyo_table {
      margin-top: 10px;
    }
  .floating_over{
          display: flex
      }
  }
  @media screen and (min-width: 961px) {
    /*PC*/
    .jokyo_table {
      max-width: 700px;
    }
    .floating_over{
      display: none
    }
  }

</style>
  